module Client.Admin.DisableUser.Grid

open Shared
open SafeStack.Client
open Client
open Client.Admin
open Elmish
open Illy.SafeStack.Client 
open Illy.SafeStack.Client.jQueryUI
open Fable.React
open Shared.Admin

type Model =
    {
        Grid: UserGrid.Model
        Disable: Disable.Model option
    }

type Msg =
    | UserGridMsg of UserGrid.Msg
    | DisableMsg of Disable.Msg
    | DisableUser of UserId
    | NotificationWasHidden

type Event =
    | ApiError of ApiError
    | CloseOverlay

let init () =
    let m, c = UserGrid.init {UserGrid.IncludeUsersFilter.all with Disabled = false}
    {
        Grid = m
        Disable = None
    }, Cmd.map UserGridMsg c

let dispatchDisableMsg model msg =
    match model.Disable with 
    | None -> model, SideEffect.none
    | Some disable ->
        let m, eff = Disable.update msg disable
        match eff with
        | SideEffect.Cmd c -> {model with Disable = Some m}, Cmd.map DisableMsg c |> SideEffect.Cmd
        | SideEffect.Event ev ->
            match ev with
            | Disable.Event.ApiError err ->
                {model with Disable = Some m}, err |> ApiError |> SideEffect.Event
            | Disable.Event.CloseOverlay ->
                {model with Disable = None}, SideEffect.none
            | Disable.Event.SaveSuccessful notification ->
                {model with Disable = None},
                Cmd.batch [
                    Notification.success notification NotificationWasHidden
                    Cmd.ofMsg (UserGrid.Msg.RefreshGrid |> UserGridMsg)
                ] |> SideEffect.Cmd

let update msg (model: Model) =
    match msg with
    | UserGridMsg uMsg ->
        let m, eff = UserGrid.update uMsg model.Grid
        {model with Grid = m},
        match eff with 
        | SideEffect.Cmd c -> Cmd.map UserGridMsg c |> SideEffect.Cmd
        | SideEffect.Event ev ->
            match ev with
            | UserGrid.Event.ApiError err -> err |> ApiError |> SideEffect.Event
            | UserGrid.Event.CloseOverlay -> CloseOverlay |> SideEffect.Event
    | DisableUser uId ->
        let m, c = Disable.init uId
        {model with Disable = Some m}, Cmd.map DisableMsg c |> SideEffect.Cmd
    | DisableMsg eMsg -> dispatchDisableMsg model eMsg
    | NotificationWasHidden -> model, SideEffect.none

let view (model: Model) dispatch =
    [
        if model.Disable.IsNone then 
            yield! UserGrid.viewModal "Disable user accounts" model.Grid (UserGridMsg >> dispatch) [
                UserGrid.GridColumn.name (UserGrid.isLoadingMoreResults model.Grid) model.Grid.SortInfo (UserGridMsg >> dispatch)
                UserGrid.GridColumn.username (UserGrid.isLoadingMoreResults model.Grid) model.Grid.SortInfo (UserGridMsg >> dispatch)
                Some [ str "Actions" ] ===> fun u -> [ UI.button "Disable" (DisableUser (UserId u.Id)) dispatch ]
            ]
        yield! jQueryUI.conditionallyRenderView model.Disable Disable.view DisableMsg dispatch
    ]
    
    
    
